/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=03bf2287"
const script = {}

import "./App.vue?vue&type=style&index=0&id=03bf2287&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.12_vue@3.5.12_webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__